@if (canViewCandidates) {
  <div class="form">
    <div
      [class.active]="isTrulyActive"
      [class.error]="taskControl.dirty && taskControl.invalid"
      [class.new-styling]="withNewStyling"
      class="container"
    >
      <rt-input
        variant="rounded"
        #textInput
        [placeholder]="placeholder"
        [maxLength]="255"
        [formControl]="taskControl"
        [rtProtectedControl]="taskControl"
        [rtProtectedControlName]="'app.candidate.tasks' | translate"
        (keyup.enter)="submit()"
        (focus)="onFocus()"
        (blur)="onBlur()"
        class="no-focus-input"
      >
      </rt-input>

      @if (isTrulyActive) {
        <div class="footer">
          @if (withNewStyling) {
            <rt-divider margin-bottom-small-x />
          }
          <div class="actions-left">
            <div layout layout-align-items-center margin-right-small-x>
              <rt-button
                (click)="dateDropdown.open = !dateDropdown.open"
                (mousedown)="setKeepFocus()"
                [pressed]="dateDropdown.open"
                #dateDropdownOrigin="rtOverlayOrigin"
                rt-overlay-origin
                class="due-date"
                variant="plain"
              >
                <rt-icon name="access-time"> </rt-icon>
                {{ getTimeDataString() || ('app.tasks.set_due_date' | translate) }}
              </rt-button>
              @if (state.timeData) {
                <rt-icon-button
                  (click)="clearTimeData()"
                  iconName="close"
                  variant="plain"
                  size="small"
                  margin-left-small-xxx
                >
                </rt-icon-button>
              }
            </div>
            <ng-template
              #dateDropdown="rtConnectedOverlay"
              rt-connected-overlay
              hasBackdrop
              [origin]="dateDropdownOrigin"
              (backdropClick)="dateDropdown.open = false"
            >
              <rt-dropdown>
                <rt-time-picker [value]="state.timeData" (valueChange)="onTimeChange($event!)">
                </rt-time-picker>
              </rt-dropdown>
            </ng-template>

            <rt-admins-avatars
              variant="rtl"
              [admins]="state.selectedAdmins || []"
              [editable]="true"
              [stacked]="true"
              [limit]="3"
              (addClick)="editAssignments()"
              (avatarsClick)="editAssignments()"
              (mousedown)="setKeepFocus()"
              margin-left-auto
            >
            </rt-admins-avatars>
          </div>
          @if (!withNewStyling && actionsVisible) {
            <div class="actions-right">
              <ng-container *ngTemplateOutlet="actionsTpl"> </ng-container>
            </div>
          }
        </div>
      }
    </div>
    @if (showActionsOutsideContainer) {
      <ng-container *ngTemplateOutlet="actionsTpl"> </ng-container>
    }
  </div>
}

<ng-template #actionsTpl>
  <rt-group
    variant="horizontal"
    [attr.margin-top-small]="withNewStyling || null"
    [attr.layout-justify-flex-end]="withNewStyling || null"
  >
    @if (!taskLoading) {
      <rt-button variant="plain" (click)="cancel()" margin-right-small>
        {{ 'app.common.cancel' | translate }}
      </rt-button>
    }
    <rt-button
      variant="primary"
      [disabled]="taskControl.invalid || taskControl.value.trim() === ''"
      [loading]="taskLoading"
      (click)="submit()"
    >
      <span> {{ 'app.common.add' | translate }}</span>
    </rt-button>
  </rt-group>
</ng-template>
